"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../../theming/make-styles.js";
const useStyles = makeStyles()((theme, { color, bordered, overflow }) => {
    const palette = theme.palette(color).list;
    return {
        list: {
            maxHeight: "inherit",
            paddingLeft: 0,
            margin: 0,
            fontSize: theme.typography.body.fontSize,
            listStyle: "none",
            overflowY: overflow ? "auto" : undefined,
            border: bordered ? `${theme.size(1)} solid ${palette.borderColor}` : undefined,
        },
    };
});
export const ListContext = React.createContext({ alignItems: "center", bordered: false, color: "primary", hoverable: false, wrap: true });
export const List = React.forwardRef(function List(_a, ref) {
    var { alignItems = "center", bordered = false, children, className, color = "primary", hoverable = false, overflow = true, wrap = true } = _a, props = __rest(_a, ["alignItems", "bordered", "children", "className", "color", "hoverable", "overflow", "wrap"]);
    const { classes, cx } = useStyles({ bordered, color, overflow });
    return (_jsx("ul", Object.assign({ ref: ref, "aria-orientation": "vertical", className: cx(classes.list, className), "data-component": "list" }, props, { children: _jsx(ListContext.Provider, { value: { alignItems, bordered, color, hoverable, wrap }, children: children }) })));
});
export default List;
//# sourceMappingURL=list.js.map